import { v4 as uuidv4 } from 'uuid';

const itemsFromBackend = [
  { id: uuidv4(), content: 'First task' },
  { id: uuidv4(), content: 'Second task' },
  { id: uuidv4(), content: 'Third task' },
  { id: uuidv4(), content: 'Fourth task' },
  { id: uuidv4(), content: 'Fifth task' },
];

const itemsFromBackend2 = [
  { id: uuidv4(), content: 'First task' },
  { id: uuidv4(), content: 'Second task' },
];

const itemsFromBackend3 = [
  { id: uuidv4(), content: 'Fifth task' },
  { id: uuidv4(), content: ' task' },
];

export { itemsFromBackend, itemsFromBackend2, itemsFromBackend3 };
